var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                !_setup.show
                  ? _c(
                      _setup.MapControlButton,
                      {
                        attrs: {
                          tooltip: _setup.$map.trans("map.layer-control.title"),
                          active: _setup.show,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.toggleShow()
                          },
                        },
                      },
                      [
                        _c(_setup.SvgIcon, {
                          attrs: {
                            size: "14",
                            type: "mdi",
                            path: _setup.path.icon,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "draggable",
            fn: function (props) {
              return [
                _c(
                  _setup.DraggableSidebar,
                  _vm._b(
                    {
                      attrs: { show: _setup.show },
                      on: {
                        "update:show": function ($event) {
                          _setup.show = $event
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "layer-control__title" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _setup.$map.trans(
                                            "map.layer-control.title"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    "DraggableSidebar",
                    props,
                    false
                  ),
                  [
                    _c("div", { staticClass: "layer-control" }, [
                      _c("div", { staticClass: "layer-control-container" }, [
                        _c("div", { staticClass: "layer-control__header" }, [
                          _c(
                            "button",
                            {
                              staticClass: "layer-item__button",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _setup.openAddLayer()
                                },
                              },
                            },
                            [
                              _c(_setup.SvgIcon, {
                                attrs: {
                                  size: "14",
                                  type: "mdi",
                                  path: _setup.path.layer.create,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "v-spacer" }),
                          _c(
                            "button",
                            {
                              staticClass: "layer-item__button",
                              on: {
                                click: function ($event) {
                                  return _setup.addNewGroup()
                                },
                              },
                            },
                            [
                              _c(_setup.SvgIcon, {
                                attrs: {
                                  size: "14",
                                  type: "mdi",
                                  path: _setup.path.group.create,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "layer-item__button",
                              on: { click: _setup.onRemoveAllLayer },
                            },
                            [
                              _c(_setup.SvgIcon, {
                                attrs: {
                                  size: "14",
                                  type: "mdi",
                                  path: _setup.path.deleteAll,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "layer-control__list" },
                          [
                            _c(_setup.DraggableGroupList, {
                              ref: "groupRef",
                              attrs: {
                                items: _setup.views,
                                groupShow: _setup.groupShow,
                                selected: _setup.layers_select,
                                disabled: _vm.disabled,
                                disabledDrag: _vm.disabledDrag,
                              },
                              on: {
                                "update:items": function ($event) {
                                  _setup.views = $event
                                },
                                "update:groupShow": function ($event) {
                                  _setup.groupShow = $event
                                },
                                "update:group-show": function ($event) {
                                  _setup.groupShow = $event
                                },
                                "update:selected": function ($event) {
                                  _setup.layers_select = $event
                                },
                                "click-drag:done": function ($event) {
                                  return _setup.updateLayers()
                                },
                                "click-group:remove": _setup.onRemoveGroupLayer,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item",
                                    fn: function ({
                                      isSelected,
                                      item,
                                      toggleSelect,
                                    }) {
                                      return [
                                        _vm._t(
                                          "item",
                                          function () {
                                            return [
                                              _c(
                                                item.component ||
                                                  _setup.LayerItem,
                                                {
                                                  tag: "component",
                                                  attrs: {
                                                    item: item,
                                                    isSelected: isSelected,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return toggleSelect(item)
                                                    },
                                                    "update:item":
                                                      _setup.onUpdateLayer,
                                                    "click:bounds":
                                                      _setup.onToBounds,
                                                    "click:remove":
                                                      _setup.onRemoveLayer,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "pre-btn",
                                                        fn: function ({
                                                          loading,
                                                        }) {
                                                          return _vm._l(
                                                            item.extra_buttons,
                                                            function (menu, i) {
                                                              return _c(
                                                                "button",
                                                                _vm._b(
                                                                  {
                                                                    key: i,
                                                                    staticClass:
                                                                      "layer-item__button",
                                                                    attrs: {
                                                                      disabled:
                                                                        loading,
                                                                      title:
                                                                        menu.name,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _setup.onLayerAction(
                                                                            menu
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  "button",
                                                                  menu.attr,
                                                                  false
                                                                ),
                                                                [
                                                                  _c(
                                                                    _setup.SvgIcon,
                                                                    {
                                                                      attrs: {
                                                                        size: "14",
                                                                        type: "mdi",
                                                                        path: menu.icon,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                        },
                                                      },
                                                      {
                                                        key: "extra-btn",
                                                        fn: function ({
                                                          loading,
                                                        }) {
                                                          return [
                                                            item.menus &&
                                                            item.menus.length >
                                                              0
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "layer-item__button",
                                                                    attrs: {
                                                                      disabled:
                                                                        loading,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          $event.stopPropagation()
                                                                          return _setup.handleContextClick(
                                                                            $event,
                                                                            item
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      _setup.SvgIcon,
                                                                      {
                                                                        attrs: {
                                                                          size: "14",
                                                                          type: "mdi",
                                                                          path: _setup
                                                                            .path
                                                                            .menu,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }
                                              ),
                                            ]
                                          },
                                          {
                                            item: item,
                                            isSelected: isSelected,
                                            toggleSelect: toggleSelect,
                                          }
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "base-map-card-container" },
                        [
                          _c(_setup.BaseMapCard, {
                            attrs: { mapId: _setup.c_mapId },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [
      _c(_setup.LayerItemContextMenu, {
        ref: "contextMenuRef",
        attrs: { options: _setup.menu_context.items },
        on: { "click:option": _setup.onLayerAction },
      }),
      _c(_setup.LayerCreateControl, {
        attrs: { show: _setup.showCreate },
        on: {
          "update:show": function ($event) {
            _setup.showCreate = $event
          },
        },
      }),
      _vm._t("default"),
      _c(_setup.StyleControl, { ref: "styleControlRef" }),
      _c(_setup.LayerComponent),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }